import lottie from 'lottie-web'
import { openPopup } from '../helpers/popups'

let advancedVideoC = $('.js-advanced-video-c')
if (window.innerWidth > 1200) {
  advancedVideoC.mouseenter(function () {
    let lottieB = $(this).find('.js-load-lottie').data('name')
    let img = $(this).find('.image')
    let video = $(this).find('video')

    lottie.setDirection(1, lottieB);
    lottie.play(lottieB);

    img.fadeOut(200)
    video[0].play()

  })
  advancedVideoC.mouseleave(function () {
    let lottieB = $(this).find('.js-load-lottie').data('name')
    let img = $(this).find('.image')
    let video = $(this).find('video')

    lottie.setDirection(-1, lottieB);
    lottie.play(lottieB);

    video[0].pause()
    img.fadeIn(400)
  })
}

advancedVideoC.click(function(){
  let url = $(this).data('youtube-url')
  let popup = $('.js-popup[data-popup="video-popup"]')

  popup.find('iframe').attr('src', url)
  openPopup('video-popup')

})

